import { render } from "./index.vue?vue&type=template&id=28a76d6a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=28a76d6a&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a76d6a"],['__file',"src/views/DashboardGestor/components/DashboardModalPermissao/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28a76d6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28a76d6a', __exports__)) {
    console.log('reload')
    api.reload('28a76d6a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=28a76d6a&scoped=true", () => {
    console.log('re-render')
    api.rerender('28a76d6a', render)
  })

}


export default __exports__